import React from 'react';

const {
    REACT_APP_ELASTIC_CENTROS_HUBTEC,
    REACT_APP_ELASTIC_CENTROS_UFRO,
    REACT_APP_ELASTIC_CENTROS_UDD,
    REACT_APP_ELASTIC_CENTROS_UNAB,
    REACT_APP_ELASTIC_CENTROS_UANDES,
    REACT_APP_ELASTIC_INVESTIGADORES_HUBTEC,
    REACT_APP_ELASTIC_INVESTIGADORES_PUC,
    REACT_APP_ELASTIC_INVESTIGADORES_UFRO,
    REACT_APP_ELASTIC_INVESTIGADORES_UDD,
    REACT_APP_ELASTIC_INVESTIGADORES_UNAB,
    REACT_APP_ELASTIC_INVESTIGADORES_UANDES,
  } = process.env;

const centrosEngines = {
    hubtec: REACT_APP_ELASTIC_CENTROS_HUBTEC,
    unab: REACT_APP_ELASTIC_CENTROS_UNAB,
    udd: REACT_APP_ELASTIC_CENTROS_UDD,   
    ufro: REACT_APP_ELASTIC_CENTROS_UFRO,
    uandes: REACT_APP_ELASTIC_CENTROS_UANDES,
}

const investigadoresEngines = {
    hubtec: REACT_APP_ELASTIC_INVESTIGADORES_HUBTEC,
    unab: REACT_APP_ELASTIC_INVESTIGADORES_UNAB,
    udd: REACT_APP_ELASTIC_INVESTIGADORES_UDD,
    uandes: REACT_APP_ELASTIC_INVESTIGADORES_UANDES,
    uc: REACT_APP_ELASTIC_INVESTIGADORES_PUC,
    ufro: REACT_APP_ELASTIC_INVESTIGADORES_UFRO
}

const contactos = {
    hubtec: <span></span>,
    unab: <span style={{fontSize: '16px'}}>Para m&aacute;s informaci&oacute;n y/o orientaci&oacute;n para acceder a las capacidades de la Universidad Andr&eacute;s Bello contactar a Francisco Chiang, Director de Innovación y Emprendimiento: <a className="link" href="mailto:francisco.chiang@unab.cl"> francisco.chiang@unab.cl </a></span>,
    udd: <span style={{fontSize: '16px'}}>Para m&aacute;s informaci&oacute;n y/o orientaci&oacute;n para acceder a las Capacidades en I+D de la Universidad del Desarrollo contactar a Sebasti&aacute;n Figueroa M, Director de Vinculación con la Industria en I+D: <a className="link" href="mailto:sebastian.figueroa@udd.cl"> sebastian.figueroa@udd.cl </a></span>,
    uandes: <span></span>,
    uc: <span></span>,
    ufro: <span></span>,
    uv: <span></span>,
}
export default [
    {
        id: 'unab',
        centros: {
            engineName: centrosEngines.unab
        },
        investigadores:{
            engineName: investigadoresEngines.unab
        },
        contacto: contactos.unab
    },
    {
        id: 'udd',
        centros: {
            engineName: centrosEngines.udd
        },
        investigadores:{
            engineName: investigadoresEngines.udd
        },
        contacto: contactos.udd
    },
    {
        id: 'uandes',
        centros: {
            engineName: centrosEngines.uandes
        },
        investigadores:{
            engineName: investigadoresEngines.uandes
        },
        contacto: contactos.uandes
    },
    {
        id: 'puc',
        centros: {
            engineName: centrosEngines.hubtec
        },
        investigadores:{
            engineName: investigadoresEngines.uc
        },
        contacto: contactos.uc
    },
    {
        id: 'ufro',
        centros: {
            engineName: centrosEngines.ufro
        },
        investigadores:{
            engineName: investigadoresEngines.ufro
        },
        contacto: contactos.ufro
    },
    {
        id: 'uv',
        centros: {
            engineName: centrosEngines.hubtec
        },
        investigadores:{
            engineName: investigadoresEngines.hubtec
        },
        contacto: contactos.uv
    },
    {
        id: 'pucv',
        centros: {
            engineName: centrosEngines.hubtec
        },
        investigadores: {
            engineName: investigadoresEngines.hubtec
        },
        contacto: contactos.hubtec
    },
    {
        id: 'caps',
        centros: {
            engineName: centrosEngines.hubtec
        },
        investigadores:{
            engineName: investigadoresEngines.hubtec
        },
        contacto: contactos.hubtec
    }
];